import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { CategoryService } from '../../../../services/category.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { Subject } from 'rxjs';
import { CreateEditCategoryComponent } from './create-edit-category/create-edit-category.component';


@Component({
  selector: 'app-config-medias',
  templateUrl: './config-medias.component.html',
  styleUrls: ['./config-medias.component.scss']
})
export class ConfigMediasComponent implements OnInit {
  dtConfig = {
    config: {
      base: this.categoryService,
      api: 'datatable',
      rowsPerPage: 10,
      order: [[1, 'desc']],
      params: {
        key: ''
      }
    },
    columns: [
      {
        title: 'ID',
        field: 'id'
      },
      {
        title: 'Nombre',
        field: 'name',
      },
			{
				title: 'Descripcion',
				field: 'description',
			}
    ],
    actions: [
      {
        display: 'Editar',
        icon: 'fa-pencil',
        event: 'category.edit',
        conditionality: 'true'
      },
      {
        display: 'Eliminar',
        icon: 'fa-trash',
        event: 'category.delete',
        conditionality: 'true'
      }
    ]
  };
  private atComponentDestroy = new Subject();
  constructor(
      private categoryService: CategoryService,
        private swal: SwalService,
        private broadcast: BroadcastService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private nrModal: NRModalService
  ) { }
  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }

  ngOnInit(): void {
    this.broadcast
    .onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
    .pipe(takeUntil(this.atComponentDestroy))
    .subscribe((event: EventModel) => {
      const props = this.prepareProps(event);
      if (props) {
        this.nrModal.open(props, 'md');
      }
    });
  }
  prepareProps(event: EventModel): any {
    const props: DynamicHostModel = new DynamicHostModel();
    props.instantiated = false;
    props.modalModel = {
      component: null,
      componentFactoryResolver: this.componentFactoryResolver,
      data: event.data.item || {}
    };
    switch (event.name) {
          case 'category.add':
            props.modalModel.component = CreateEditCategoryComponent;
            props.modalModel.modalConfiguration = {
              title: 'Agregar Categoria'
            };
            break;
    
          case 'category.edit':
            props.modalModel.component = CreateEditCategoryComponent;
            props.modalModel.modalConfiguration = {
              title: 'Editar Categoria'
            };
            break;
          case 'category.delete':
            this.delete(event.data);
            return false;
        }
    
        return props;
  }
   /**
   * Abre el modal para agregar una Categoria
   */
   add(): void {
    this.broadcast.fire({
      name: 'category.add',
      type: EventType.MODAL,
      data: {}
    });
  }

  /**
   * Elimina una Categoria tras la confirmación
   */
  delete(data): void {
    const swalParams = {
      title: '¿Estás seguro de querer eliminar esta categoria?',
      text: 'La categoria será marcada como eliminado, pero podrá restaurarse.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    };
  
    this.swal.warning(swalParams).then(result => {
      if (result.value) {
        this.categoryService.delete(data.item.id).subscribe(response => {
          this.swal.success({ title: 'Categoria eliminada con exito' }).then(() => {
            this.broadcast.reloadDataTable();
          });
        }, error => {
          console.error('Error al eliminar:', error);
          this.swal.error('Ocurrió un error al intentar eliminar la categoria');
        });
      }
    });
  }
}
